<template>
  <lego-toast width="50%" position="top right" />
</template>
<script>

export default {
  methods: {
    open(message) {
      this.el = true;
      this.message = message;
    },
  },
  data() {
    return {
      el: null,
      message: '',
    };
  },
};
</script>
